exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".change-bill-content[data-v-41db5c97]{margin-top:16px}.loading-wrapper[data-v-41db5c97]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:378px}.change-bill-alert[data-v-41db5c97]{margin-bottom:20px}.change-bill-alert .alert-tips[data-v-41db5c97]{list-style:disc;margin:0;padding-left:8px}.change-bill-alert .alert-tips li[data-v-41db5c97]{list-style:disc;line-height:1.6}.change-bill-alert .alert-tips li+li[data-v-41db5c97]{margin-top:6px}", ""]);

// exports
